import React, { Component } from "react";
class Input extends Component {
  constructor(props) {
    super(props);

    this.state = {};
  }

  render() {
    const {
      forName,
      classLabel,
      label,
      type,
      name,
      placeholder,
      classInput,
      value,
      handleChange,
      handleOnBlur,
      id,
      handleFocus,
    } = this.props;
    return (
      <React.Fragment>
        <div>
          <label for={forName} class={classLabel}>
            {label}
          </label>

          {handleFocus ? (
            <input
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
              type={type}
              id={id}
              name={name}
              placeholder={placeholder}
              class={classInput}
              value={value}
              onChange={handleChange}
              onBlur={handleOnBlur(name)}
              onFocus={handleFocus(name)}
            />
          ) : (
            <input
              autoComplete="off"
              spellcheck="false"
              aria-autocomplete="both"
              aria-haspopup="false"
              type={type}
              id={id}
              name={name}
              placeholder={placeholder}
              class={classInput}
              value={value}
              onChange={handleChange}
              onBlur={handleOnBlur(name)}
            />
          )}
        </div>
      </React.Fragment>
    );
  }
}
export default Input;
